module.exports = __webpack_public_path__ + "img/paragraph.8f698f10.svg";